import { apiClient } from './ticketsApi';
import { ENDPOINTS } from './endpoints';

export const fetchSourceInfoList = async () => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.GET_SOURCE_INFO}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching source info:', error.response?.data || error.message);
        throw error;
    }
};

export const createSourceInfo = async (payload) => {
    try {
        const response = await apiClient.post(`/api${ENDPOINTS.CREATE_SOURCE_INFO}`, payload, {
            headers: { 'Content-Type': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error('Error creating source info:', error.response?.data || error.message);
        throw error;
    }
};

// Backend route is PUT /api/SourceInfo/{id} with an integer id (confirmed via
// the live swagger contract — it 404s if a non-numeric value like Code is passed).
export const updateSourceInfo = async (id, payload) => {
    try {
        const response = await apiClient.put(`/api${ENDPOINTS.UPDATE_SOURCE_INFO}/${id}`, payload, {
            headers: { 'Content-Type': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating source info:', error.response?.data || error.message);
        throw error;
    }
};

// POST /api/AirlineRefreshConfiguration/Config — expects AirlineRefreshModel
// { Airline, Code, Url, OperatingCarrier, IsSimplified, IsActive }.
export const updateAirlineConfiguration = async (payload) => {
    try {
        const response = await apiClient.post(`/api${ENDPOINTS.UPDATE_AIRLINE_CONFIGURATION}`, payload, {
            headers: { 'Content-Type': 'application/json' }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating airline configuration:', error.response?.data || error.message);
        throw error;
    }
};
